<script setup></script>
<template>
  <div>
    <h1>LAMDIK</h1>
  </div>
</template>
